// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nOZXe_X1Rj805Y98 {
  width: 350px;
  height: 520px;
  border: 2px solid #20336c;
  border-radius: 25px;
  overflow: hidden;
  box-shadow: 3px 3px 0 0 #20336c;
  background-color: #F9F9F9;
}

.nOZXe_X1Rj805Y98.VglfDXSlCFMqCb0e {
  background-color: #faf8f2;
}

.DWDRvtbJo9krFhe6 {
  padding: 36px 36px 0;
}

.G0_pnowdYdoNJLmc {
  display: flex;
  justify-content: space-between;
  margin-bottom: 37px;
  font-size: 16px;
}

.G0_pnowdYdoNJLmc div:first-child {
  color: #20336c;
  font-weight: 800;
}

.G0_pnowdYdoNJLmc div:last-child {
  color: #5b5b5b;
}

.J0QKiLc86H4k16ir {
  height: 315px;
  overflow-y: auto;
}

.pWtGxjuRvIA_usVG {
  display: flex;
  border-top: 1px solid #c0c0c0;
  padding: 18px 3px;
  font-size: 14px;
}

.PBiTdAWvtEcPQqnD {
  width: 115px;
  font-weight: bold;
  flex-shrink: 0;
}

.QRGNRyCkNIocXdBG {
  background-color: #ffe2d9;
  text-transform: uppercase;
}

.aFWuLAe2JkBwtcFk {
  display: flex;
  margin: 0 20px 52px;
  gap: 12px;
}

.aFWuLAe2JkBwtcFk button {
  width: 100%;
  height: 63px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 14px;
  display: flex;
  justify-content: center;
  text-transform: uppercase;
}

.aFWuLAe2JkBwtcFk button:first-child {
  background-color: transparent;
  border: 2px solid #20336c;
  color: #20336c;
}

.aFWuLAe2JkBwtcFk button:first-child i {
  margin-right: 13px;
  font-size: 19px;
}

.aFWuLAe2JkBwtcFk button:last-child {
  background-color: #339c49;
}

.aFWuLAe2JkBwtcFk button:last-child img {
  margin-right: 12px;
}

.i1hOhdzAqEf5IUxl,
._w2pGMDjimAVEKsW {
  padding: 4px;
}

.i1hOhdzAqEf5IUxl {
  background-color: #c2c2c2;
}

.oiNmoWSDIG0SihS_ {
  display: none;
  @media print {
    display: block;
    width: 100%;
    padding: 50px;
    font-size: 30px;
    background-color: #ffffff;
  }
}

.cEjC6W9fxTQNyIzc {
  font-size: 20px;
}

.Sh85P37Cs2dpEhiW {
  font-size: 28px;
}

.Sv9NvnqgdUdr5lvU {
  font-size: 45px;
}

.YQWe9wjRG3QRnVao {
  height: 3px;
  background-color: black;
  margin: 10px 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Chef/OrderCard.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb;IACE,cAAc;IACd,WAAW;IACX,aAAa;IACb,eAAe;IACf,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,cAAc;AAChB","sourcesContent":[".orderCard {\r\n  width: 350px;\r\n  height: 520px;\r\n  border: 2px solid #20336c;\r\n  border-radius: 25px;\r\n  overflow: hidden;\r\n  box-shadow: 3px 3px 0 0 #20336c;\r\n  background-color: #F9F9F9;\r\n}\r\n\r\n.orderCard.printed {\r\n  background-color: #faf8f2;\r\n}\r\n\r\n.orderDataWrapper {\r\n  padding: 36px 36px 0;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-bottom: 37px;\r\n  font-size: 16px;\r\n}\r\n\r\n.header div:first-child {\r\n  color: #20336c;\r\n  font-weight: 800;\r\n}\r\n\r\n.header div:last-child {\r\n  color: #5b5b5b;\r\n}\r\n\r\n.dataWrapper {\r\n  height: 315px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.row {\r\n  display: flex;\r\n  border-top: 1px solid #c0c0c0;\r\n  padding: 18px 3px;\r\n  font-size: 14px;\r\n}\r\n\r\n.rowHeader {\r\n  width: 115px;\r\n  font-weight: bold;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.allergyRow {\r\n  background-color: #ffe2d9;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.orderButtons {\r\n  display: flex;\r\n  margin: 0 20px 52px;\r\n  gap: 12px;\r\n}\r\n\r\n.orderButtons button {\r\n  width: 100%;\r\n  height: 63px;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  border-radius: 14px;\r\n  display: flex;\r\n  justify-content: center;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.orderButtons button:first-child {\r\n  background-color: transparent;\r\n  border: 2px solid #20336c;\r\n  color: #20336c;\r\n}\r\n\r\n.orderButtons button:first-child i {\r\n  margin-right: 13px;\r\n  font-size: 19px;\r\n}\r\n\r\n.orderButtons button:last-child {\r\n  background-color: #339c49;\r\n}\r\n\r\n.orderButtons button:last-child img {\r\n  margin-right: 12px;\r\n}\r\n\r\n.headerRow,\r\n.dataRow {\r\n  padding: 4px;\r\n}\r\n\r\n.headerRow {\r\n  background-color: #c2c2c2;\r\n}\r\n\r\n.printedView {\r\n  display: none;\r\n  @media print {\r\n    display: block;\r\n    width: 100%;\r\n    padding: 50px;\r\n    font-size: 30px;\r\n    background-color: #ffffff;\r\n  }\r\n}\r\n\r\n.extraSmallFont {\r\n  font-size: 20px;\r\n}\r\n\r\n.smallFont {\r\n  font-size: 28px;\r\n}\r\n\r\n.bigFont {\r\n  font-size: 45px;\r\n}\r\n\r\n.divider {\r\n  height: 3px;\r\n  background-color: black;\r\n  margin: 10px 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var orderCard = `nOZXe_X1Rj805Y98`;
export var printed = `VglfDXSlCFMqCb0e`;
export var orderDataWrapper = `DWDRvtbJo9krFhe6`;
export var header = `G0_pnowdYdoNJLmc`;
export var dataWrapper = `J0QKiLc86H4k16ir`;
export var row = `pWtGxjuRvIA_usVG`;
export var rowHeader = `PBiTdAWvtEcPQqnD`;
export var allergyRow = `QRGNRyCkNIocXdBG`;
export var orderButtons = `aFWuLAe2JkBwtcFk`;
export var headerRow = `i1hOhdzAqEf5IUxl`;
export var dataRow = `_w2pGMDjimAVEKsW`;
export var printedView = `oiNmoWSDIG0SihS_`;
export var extraSmallFont = `cEjC6W9fxTQNyIzc`;
export var smallFont = `Sh85P37Cs2dpEhiW`;
export var bigFont = `Sv9NvnqgdUdr5lvU`;
export var divider = `YQWe9wjRG3QRnVao`;
export default ___CSS_LOADER_EXPORT___;
